import React, { useState } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Switch,
  message,
} from "antd";
import "./index.css";
import HeadingComponent from "../../../components/HeadingComponent";
import DeleteModal from "../../../components/DeleteModal";
import {
  inviteMember,
  removeMember,
} from "../../Members/APIs/firebaseMemberSettingApi";
import { assignPropertyIfMemberExist } from "../../Auth/APIs/authApis";
import { getRoleBySlug, updateUser } from "../../../firebase/queries";

const { Option } = Select;

const UserDrawer = (props) => {
  const {
    showDrawer,
    hideModal,
    setLoading,
    modalData,
    loading,
    properties,
    user,
    roles,
  } = props;

  const [user_properties, setUserProperties] = useState(
    properties?.filter((property) =>
      modalData?.assigned_property_ids.includes(property.id.toString())
    )
  );

  const handleDeleteMember = async (record) => {
    setLoading(true);
    const property = properties.find((row) => row.id === record?.id);
    let admins = property.admins || [];
    admins = admins.filter((row) => row !== modalData?.id);
    await removeMember(modalData?.id, record?.id, admins).finally(() => {
      setLoading(false);
    });

    setUserProperties(
      user_properties?.filter((item) => item?.id !== record?.id)
    );
    message.success("Property deleted");
  };

  const handleAdd = async (member, selectedProperty, formValues) => {
    const property = properties.find((row) => row.id === selectedProperty?.id);
    const role = roles.find((row) => row.name === formValues.role);
    const obj = {
      ...formValues,
      role,
      invitedBy: user.name,
      invitedById: user.id,
      propertyId: selectedProperty?.id,
      propertyName: property.name,
      sendEmail: false,
    };
    setLoading(true);
    const response = await inviteMember(obj);
    const result = await assignPropertyIfMemberExist(
      formValues?.email,
      selectedProperty?.id,
      true
    ).finally(() => {
      setLoading(false);
    });

    if (response) {
      message.info("Propeerty Added");
    }
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const { assigned_properties, ...rest } = values;
      const role = await getRoleBySlug(rest?.role);
      const user_data = {
        name: rest?.name,
        email: rest?.email,
        role,
        isBanned: rest?.isBanned,
      };
      const updatedUser = await updateUser(user_data, modalData?.id);
      const filteredProperties = properties?.filter((prop) => {
        return values?.assigned_properties?.some((p) => p.name === prop.id);
      });
      await Promise.all(
        filteredProperties?.map(async (property) => {
          await handleAdd(modalData, property, rest);
        })
      );
      setUserProperties(user_properties?.concat(filteredProperties));
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={modalData?.name}
      width={720}
      onClose={hideModal}
      open={showDrawer}
      styles={{
        body: {
          paddingBottom: 80,
        },
      }}
    >
      <Form
        layout="vertical"
        hideRequiredMark
        onFinish={onFinish}
        initialValues={{
          name: modalData?.name,
          email: modalData?.email,
          role: modalData?.role?.slug,
          isBanned: modalData?.isBanned,
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="name"
              label="Name"
              rules={[
                {
                  required: true,
                  message: "Please enter user name",
                },
              ]}
            >
              <Input placeholder="Please enter user name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="email" label="Email">
              <Input disabled placeholder="Please enter user name" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="role" label="Role">
              <Select placeholder="Please select role">
                <Option value="admin">Admin</Option>
                <Option value="super_admin">Super Admin</Option>
                <Option value="agent">Agent</Option>
                <Option value="moderator">Moderator</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="isBanned" label="isBanned">
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <div>
              <HeadingComponent text="Assigned Properties" />
            </div>
            <ul className="assign_props_list">
              {user_properties?.map((item) => (
                <div className="list_item">
                  <li key={item?.id} value={item?.id}>
                    {item?.name}
                  </li>

                  <DeleteModal
                    handleDelete={() => handleDeleteMember(item)}
                    title="Are you sure you want to delete this property from this user?"
                  />
                </div>
              ))}
            </ul>
          </Col>
        </Row>

        <br />
        <Row gutter={16}>
          <Col span={24}>
            <Form.List name="assigned_properties">
              {(fields, { add, remove }) => (
                <>
                  {fields?.map(({ key, name, ...restField }) => {
                    return (
                      <Space
                        key={key}
                        style={{
                          display: "flex",
                          marginBottom: 8,
                        }}
                        align="baseline"
                        className="dynamic_form_space"
                      >
                        <Form.Item {...restField} name={[name, "name"]}>
                          <Select placeholder="Please select property">
                            {properties
                              ?.filter(
                                (property) =>
                                  !modalData?.assigned_property_ids.includes(
                                    property.id.toString()
                                  )
                              )
                              ?.map((item) => (
                                <Option key={item?.id} value={item?.id}>
                                  {item?.name}
                                </Option>
                              ))}
                          </Select>
                        </Form.Item>

                        <DeleteOutlined onClick={() => remove(name)} />
                      </Space>
                    );
                  })}
                  <Form.Item>
                    <Button onClick={() => add()} block icon={<PlusOutlined />}>
                      Assign Property
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>

          <Form.Item labelAlign="right">
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </Form.Item>
        </Row>
      </Form>
    </Drawer>
  );
};

export default UserDrawer;
